// Shuriken PMO-P — Design System & Theme Engine
// 10 selectable themes, persisted in localStorage

export const THEMES = {
  DARK_NAVY:         "dark_navy",
  CLEAN_NAVY:        "clean_navy",
  OBSIDIAN:          "obsidian",
  GRAYFUL:           "grayful",
  NATURE:            "nature",
  // ── From NexGen ──
  NEXGEN_DARK:       "nexgen_dark",
  NATURE_WARM:       "nature_warm",
  GRAYFUL_PURPLE:    "grayful_purple",
  CLEAN_NAVY_LIGHT:  "clean_navy_light",
  // ── Monochrome ──
  MONOCHROME_BW:     "monochrome_bw",
};

const themes = {
  // ── Original PMO themes ──────────────────────────────────────────────────
  dark_navy: {
    name: "Dark Navy",
    bg:           "#050D1A",
    sidebar:      "#080F1E",
    card:         "#0C1628",
    cardBorder:   "#1A2744",
    accent:       "#C9A84C",
    accentDim:    "#A08030",
    accentGlow:   "rgba(201,168,76,0.15)",
    accentText:   "#C9A84C",
    cyan:         "#00D4FF",
    cyanGlow:     "rgba(0,212,255,0.15)",
    danger:       "#FF3D57",
    dangerGlow:   "rgba(255,61,87,0.15)",
    warning:      "#FFB800",
    success:      "#00E676",
    textPrimary:  "#F0F8FF",
    textSecondary:"#A8C8E8",
    textMuted:    "#6B8DB0",
    textLabel:    "#8BB8D8",
    buttonText:   "#000000",
    headerGrad:   "linear-gradient(135deg, #050D1A 0%, #0C1628 100%)",
    sidebarGrad:  "linear-gradient(180deg, #080F1E 0%, #050D1A 100%)",
    chartColors:  ["#C9A84C","#00D4FF","#FF3D57","#FFB800","#00E676","#A78BFA","#F97316","#EC4899","#14B8A6","#84CC16"],
  },
  clean_navy: {
    name: "Clean Navy",
    bg:           "#0A1628",
    sidebar:      "#0D1E35",
    card:         "#112040",
    cardBorder:   "#1E3A5F",
    accent:       "#00D4FF",
    accentDim:    "#0099BB",
    accentGlow:   "rgba(0,212,255,0.18)",
    accentText:   "#00D4FF",
    cyan:         "#00D4FF",
    cyanGlow:     "rgba(0,212,255,0.18)",
    danger:       "#FF3D57",
    dangerGlow:   "rgba(255,61,87,0.15)",
    warning:      "#FFB800",
    success:      "#00E676",
    textPrimary:  "#EBF4FF",
    textSecondary:"#90B8D8",
    textMuted:    "#5A7A9A",
    textLabel:    "#7A9AB8",
    buttonText:   "#000000",
    headerGrad:   "linear-gradient(135deg, #0A1628 0%, #112040 100%)",
    sidebarGrad:  "linear-gradient(180deg, #0D1E35 0%, #0A1628 100%)",
    chartColors:  ["#00D4FF","#C9A84C","#FF3D57","#FFB800","#00E676","#A78BFA","#F97316","#EC4899","#14B8A6","#84CC16"],
  },
  obsidian: {
    name: "Obsidian",
    bg:           "#0A0A0F",
    sidebar:      "#0F0F18",
    card:         "#141420",
    cardBorder:   "#2A2A40",
    accent:       "#C9A84C",
    accentDim:    "#A08030",
    accentGlow:   "rgba(201,168,76,0.18)",
    accentText:   "#C9A84C",
    cyan:         "#7B68EE",
    cyanGlow:     "rgba(123,104,238,0.18)",
    danger:       "#FF3D57",
    dangerGlow:   "rgba(255,61,87,0.15)",
    warning:      "#FFB800",
    success:      "#00E676",
    textPrimary:  "#F5F5FF",
    textSecondary:"#B0A8D0",
    textMuted:    "#7068A0",
    textLabel:    "#9088B8",
    buttonText:   "#000000",
    headerGrad:   "linear-gradient(135deg, #0A0A0F 0%, #141420 100%)",
    sidebarGrad:  "linear-gradient(180deg, #0F0F18 0%, #0A0A0F 100%)",
    chartColors:  ["#C9A84C","#7B68EE","#FF3D57","#FFB800","#00E676","#EC4899","#F97316","#14B8A6","#84CC16","#00D4FF"],
  },
  grayful: {
    name: "Grayful",
    bg:           "#141414",
    sidebar:      "#1A1A1A",
    card:         "#202020",
    cardBorder:   "#333333",
    accent:       "#E8C547",
    accentDim:    "#C0A030",
    accentGlow:   "rgba(232,197,71,0.15)",
    accentText:   "#E8C547",
    cyan:         "#64B5F6",
    cyanGlow:     "rgba(100,181,246,0.15)",
    danger:       "#EF5350",
    dangerGlow:   "rgba(239,83,80,0.15)",
    warning:      "#FFA726",
    success:      "#66BB6A",
    textPrimary:  "#F5F5F5",
    textSecondary:"#BDBDBD",
    textMuted:    "#757575",
    textLabel:    "#9E9E9E",
    buttonText:   "#000000",
    headerGrad:   "linear-gradient(135deg, #141414 0%, #202020 100%)",
    sidebarGrad:  "linear-gradient(180deg, #1A1A1A 0%, #141414 100%)",
    chartColors:  ["#E8C547","#64B5F6","#EF5350","#FFA726","#66BB6A","#BA68C8","#FF8A65","#F06292","#4DB6AC","#AED581"],
  },
  nature: {
    name: "Nature",
    bg:           "#071A0A",
    sidebar:      "#0A1F0D",
    card:         "#0E2612",
    cardBorder:   "#1A4020",
    accent:       "#C9A84C",
    accentDim:    "#A08030",
    accentGlow:   "rgba(201,168,76,0.15)",
    accentText:   "#C9A84C",
    cyan:         "#27AE60",
    cyanGlow:     "rgba(39,174,96,0.18)",
    danger:       "#E74C3C",
    dangerGlow:   "rgba(231,76,60,0.15)",
    warning:      "#F39C12",
    success:      "#2ECC71",
    textPrimary:  "#F0FFF4",
    textSecondary:"#A8D8B0",
    textMuted:    "#5A8A62",
    textLabel:    "#7AAA82",
    buttonText:   "#000000",
    headerGrad:   "linear-gradient(135deg, #071A0A 0%, #0E2612 100%)",
    sidebarGrad:  "linear-gradient(180deg, #0A1F0D 0%, #071A0A 100%)",
    chartColors:  ["#C9A84C","#27AE60","#E74C3C","#F39C12","#2ECC71","#8E44AD","#E67E22","#EC407A","#16A085","#9BC53D"],
  },

  // ── NexGen themes (ported) ───────────────────────────────────────────────
  nexgen_dark: {
    name: "Dark",
    bg:           "#050D1A",
    sidebar:      "#080F1E",
    card:         "#0C1628",
    cardBorder:   "#1A2744",
    accent:       "#00D4FF",
    accentDim:    "#0099BB",
    accentGlow:   "rgba(0,212,255,0.15)",
    accentText:   "#00D4FF",
    cyan:         "#00D4FF",
    cyanGlow:     "rgba(0,212,255,0.15)",
    danger:       "#FF3D57",
    dangerGlow:   "rgba(255,61,87,0.15)",
    warning:      "#FFB800",
    success:      "#00E676",
    textPrimary:  "#F0F8FF",
    textSecondary:"#A8C8E8",
    textMuted:    "#6B8DB0",
    textLabel:    "#8BB8D8",
    buttonText:   "#000000",
    headerGrad:   "linear-gradient(135deg, #050D1A 0%, #0C1628 100%)",
    sidebarGrad:  "linear-gradient(180deg, #080F1E 0%, #050D1A 100%)",
    chartColors:  ["#00D4FF","#FF3D57","#FFB800","#00E676","#A78BFA","#F97316","#EC4899","#14B8A6","#84CC16","#FB923C"],
  },
  nature_warm: {
    name: "Nature Warm",
    bg:           "#EBD2B4",
    sidebar:      "#E3D8C4",
    card:         "#FFF5E6",
    cardBorder:   "#B99C7A",
    accent:       "#4F746C",
    accentDim:    "#476972",
    accentGlow:   "rgba(79,116,108,0.18)",
    accentText:   "#4F746C",
    cyan:         "#4F746C",
    cyanGlow:     "rgba(79,116,108,0.18)",
    danger:       "#985646",
    dangerGlow:   "rgba(152,86,70,0.15)",
    warning:      "#BF8859",
    success:      "#6D7961",
    textPrimary:  "#4F3F3A",
    textSecondary:"#755C57",
    textMuted:    "#8A7070",
    textLabel:    "#755C57",
    buttonText:   "#FFF5E6",
    headerGrad:   "linear-gradient(135deg, #EBD2B4 0%, #FFF5E6 100%)",
    sidebarGrad:  "linear-gradient(180deg, #E3D8C4 0%, #EBD2B4 100%)",
    chartColors:  ["#985646","#4F746C","#BF8859","#6D7961","#476972","#C07869","#8DA279","#F39474","#6CA2AF","#9B7E78"],
  },
  grayful_purple: {
    name: "Grayful Purple",
    bg:           "#131216",
    sidebar:      "#131216",
    card:         "#2E2D30",
    cardBorder:   "#54535C",
    accent:       "#A78BFA",
    accentDim:    "#7E57C2",
    accentGlow:   "rgba(167,139,250,0.16)",
    accentText:   "#A78BFA",
    cyan:         "#A78BFA",
    cyanGlow:     "rgba(167,139,250,0.16)",
    danger:       "#EF3333",
    dangerGlow:   "rgba(239,51,51,0.13)",
    warning:      "#FF9800",
    success:      "#2E9D44",
    textPrimary:  "#ECECEC",
    textSecondary:"#C7C8C9",
    textMuted:    "#8AA8C6",
    textLabel:    "#7FA3C5",
    buttonText:   "#131216",
    headerGrad:   "linear-gradient(135deg, #131216 0%, #2E2D30 100%)",
    sidebarGrad:  "linear-gradient(180deg, #131216 0%, #131216 100%)",
    chartColors:  ["#EF3333","#FF8C00","#F9A825","#2E9D44","#1565C0","#A78BFA","#00A0B5","#EC4899","#8AA8C6","#C7C8C9"],
  },
  clean_navy_light: {
    name: "Clean Navy Light",
    bg:           "#FFFFFF",
    sidebar:      "#F4F7FC",
    card:         "#FFFFFF",
    cardBorder:   "#D0D8E8",
    accent:       "#1A5A9A",
    accentDim:    "#104078",
    accentGlow:   "rgba(26,90,154,0.12)",
    accentText:   "#1A5A9A",
    cyan:         "#1A5A9A",
    cyanGlow:     "rgba(26,90,154,0.12)",
    danger:       "#AA2233",
    dangerGlow:   "rgba(170,34,51,0.12)",
    warning:      "#B8860B",
    success:      "#1A6A30",
    textPrimary:  "#1A2744",
    textSecondary:"#2A3A5A",
    textMuted:    "#5A6A84",
    textLabel:    "#345B86",
    buttonText:   "#FFFFFF",
    headerGrad:   "linear-gradient(135deg, #FFFFFF 0%, #F8FAFD 100%)",
    sidebarGrad:  "linear-gradient(180deg, #F4F7FC 0%, #FFFFFF 100%)",
    chartColors:  ["#1A5A9A","#AA2233","#B8860B","#1A6A30","#4060A0","#8B5E3C","#2A7A6A","#AA4466","#3A7A9A","#6A6A3A"],
  },

  // ── Black & White ────────────────────────────────────────────────────────
  monochrome_bw: {
    name: "Black & White",
    bg:           "#000000",
    sidebar:      "#000000",
    card:         "#000000",
    cardBorder:   "#FFFFFF",
    accent:       "#FFFFFF",
    accentDim:    "#CCCCCC",
    accentGlow:   "rgba(255,255,255,0.10)",
    accentText:   "#FFFFFF",
    cyan:         "#FFFFFF",
    cyanGlow:     "rgba(255,255,255,0.10)",
    danger:       "#FFFFFF",
    dangerGlow:   "rgba(255,255,255,0.10)",
    warning:      "#FFFFFF",
    success:      "#FFFFFF",
    textPrimary:  "#FFFFFF",
    textSecondary:"#DDDDDD",
    textMuted:    "#AAAAAA",
    textLabel:    "#CCCCCC",
    buttonText:   "#000000",
    headerGrad:   "#000000",
    sidebarGrad:  "#000000",
    chartColors:  ["#FFFFFF","#FFFFFF","#FFFFFF","#FFFFFF","#FFFFFF","#FFFFFF","#FFFFFF","#FFFFFF","#FFFFFF","#FFFFFF"],
  },
};

export function getTheme(name) {
  const t = themes[name] || themes.dark_navy;
  return {
    ...t,
    inputBg:      t.inputBg      ?? t.card,
    cardElevated: t.cardElevated ?? t.card,
  };
}

export function getThemeNames() {
  return Object.entries(themes).map(([key, t]) => ({ key, name: t.name }));
}

export function buildGlobalStyles(t) {
  const isBW = t.name === "Black & White";
  const isLight = t.bg === "#FFFFFF" || t.bg === "#EBD2B4";

  return `
    @import url('https://fonts.googleapis.com/css2?family=Orbitron:wght@400;600;700;900&family=Exo+2:wght@300;400;500;600;700&family=Share+Tech+Mono&display=swap');

    *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

    body {
      background: ${t.bg};
      color: ${t.textPrimary};
      font-family: 'Exo 2', 'Segoe UI', sans-serif;
      overflow-x: hidden;
    }

    ::-webkit-scrollbar { width: 6px; height: 6px; }
    ::-webkit-scrollbar-track { background: ${t.sidebar}; }
    ::-webkit-scrollbar-thumb { background: ${t.cardBorder}; border-radius: 3px; }
    ::-webkit-scrollbar-thumb:hover { background: ${t.accent}44; }

    .pmo-card {
      background: ${t.card};
      border: 1px solid ${t.cardBorder};
      border-radius: 12px;
      padding: 20px;
      transition: border-color 0.2s, box-shadow 0.2s;
    }

    .pmo-card:hover {
      border-color: ${t.accent}33;
      box-shadow: 0 0 20px ${t.accentGlow};
    }

    .glow-text {
      color: ${t.accent};
      text-shadow: 0 0 20px ${t.accentGlow};
    }

    ${isBW ? `
      .rag-green  { background: #111111; color: #FFFFFF; border: 1px solid #FFFFFF; }
      .rag-amber  { background: #111111; color: #FFFFFF; border: 1px solid #FFFFFF; }
      .rag-red    { background: #111111; color: #FFFFFF; border: 1px solid #FFFFFF; }
      .rag-blue   { background: #111111; color: #FFFFFF; border: 1px solid #FFFFFF; }
      .rag-grey   { background: #111111; color: #AAAAAA; border: 1px solid #AAAAAA; }
    ` : `
      .rag-green  { background: rgba(0,230,118,0.15);   color: #00E676; border: 1px solid #00E67644; }
      .rag-amber  { background: rgba(255,184,0,0.15);   color: #FFB800; border: 1px solid #FFB80044; }
      .rag-red    { background: rgba(255,61,87,0.15);   color: #FF3D57; border: 1px solid #FF3D5744; }
      .rag-blue   { background: rgba(0,212,255,0.15);   color: #00D4FF; border: 1px solid #00D4FF44; }
      .rag-grey   { background: rgba(107,141,176,0.15); color: #6B8DB0; border: 1px solid #6B8DB044; }
    `}

    .badge {
      display: inline-block;
      padding: 2px 10px;
      border-radius: 20px;
      font-size: 11px;
      font-weight: 600;
      letter-spacing: 0.5px;
      text-transform: uppercase;
    }

    @keyframes scanline {
      0%   { transform: translateY(-100%); }
      100% { transform: translateY(100vh); }
    }

    @keyframes pulse-glow {
      0%, 100% { box-shadow: 0 0 5px ${t.accentGlow}; }
      50%       { box-shadow: 0 0 20px ${t.accent}88; }
    }

    @keyframes fadeInUp {
      from { opacity: 0; transform: translateY(16px); }
      to   { opacity: 1; transform: translateY(0); }
    }

    @keyframes spin-shuriken {
      from { transform: rotate(0deg); }
      to   { transform: rotate(360deg); }
    }

    .animate-in { animation: fadeInUp 0.35s ease forwards; }

    input, select, textarea {
      background: ${t.card};
      border: 1px solid ${t.cardBorder};
      color: ${t.textPrimary};
      border-radius: 6px;
      padding: 8px 12px;
      font-family: 'Exo 2', sans-serif;
      font-size: 14px;
      outline: none;
      transition: border-color 0.2s;
    }
    input:focus, select:focus, textarea:focus {
      border-color: ${t.accent};
      box-shadow: 0 0 0 2px ${t.accentGlow};
    }
    ${isLight ? `
      input, select, textarea { color-scheme: light; }
      select option { background: ${t.card}; color: ${t.textPrimary}; }
    ` : ''}

    table { width: 100%; border-collapse: collapse; }
    th {
      background: ${t.sidebar};
      color: ${t.textSecondary};
      font-size: 11px;
      font-weight: 600;
      letter-spacing: 0.8px;
      text-transform: uppercase;
      padding: 10px 14px;
      text-align: left;
      border-bottom: 1px solid ${t.cardBorder};
    }
    td {
      padding: 10px 14px;
      border-bottom: 1px solid ${t.cardBorder}44;
      font-size: 13px;
      color: ${t.textSecondary};
    }
    tr:hover td { background: ${t.accent}08; }

    .btn-primary {
      background: ${isLight ? `linear-gradient(135deg, ${t.accent}, ${t.accentDim})` : `linear-gradient(135deg, ${t.accent}, ${t.accentDim})`};
      color: ${t.buttonText || "#000"};
      border: none;
      padding: 9px 20px;
      border-radius: 6px;
      font-family: 'Exo 2', sans-serif;
      font-size: 13px;
      font-weight: 700;
      letter-spacing: 0.8px;
      text-transform: uppercase;
      cursor: pointer;
      transition: opacity 0.2s, transform 0.1s;
    }
    .btn-primary:hover { opacity: 0.88; transform: translateY(-1px); }

    .btn-secondary {
      background: transparent;
      color: ${t.accent};
      border: 1px solid ${t.accent}66;
      padding: 9px 20px;
      border-radius: 6px;
      font-family: 'Exo 2', sans-serif;
      font-size: 13px;
      font-weight: 600;
      letter-spacing: 0.8px;
      text-transform: uppercase;
      cursor: pointer;
      transition: background 0.2s;
    }
    .btn-secondary:hover { background: ${t.accentGlow}; }

    .section-title {
      font-family: 'Orbitron', monospace;
      font-size: 11px;
      font-weight: 700;
      letter-spacing: 2px;
      text-transform: uppercase;
      color: ${t.accent};
      margin-bottom: 16px;
      display: flex;
      align-items: center;
      gap: 8px;
    }
    .section-title::after {
      content: '';
      flex: 1;
      height: 1px;
      background: linear-gradient(90deg, ${t.accent}44, transparent);
    }

    ${isBW ? `
      /* ── Black & White chart overrides ── */
      .recharts-bar-rectangle rect,
      .recharts-bar-rectangle path,
      .recharts-layer.recharts-bar-rectangle path {
        fill: #FFFFFF !important;
        stroke: #000000 !important;
        stroke-width: 1.5 !important;
      }
      .recharts-pie-sector path,
      .recharts-pie-sector .recharts-sector {
        stroke: #000000 !important;
        stroke-width: 2 !important;
      }
      .recharts-cell {
        stroke: #000000 !important;
        stroke-width: 2 !important;
      }
      .recharts-line-curve { stroke: #FFFFFF !important; }
      .recharts-area-area { fill: rgba(255,255,255,0.15) !important; }
      .recharts-area-curve { stroke: #FFFFFF !important; }
      .recharts-scatter-symbol circle { fill: #FFFFFF !important; stroke: #000000 !important; stroke-width: 1.5 !important; }
      .recharts-cartesian-axis-tick-value,
      .recharts-cartesian-axis-tick text { fill: #FFFFFF !important; }
      .recharts-cartesian-grid line { stroke: rgba(255,255,255,0.15) !important; }
      .recharts-legend-item-text { color: #FFFFFF !important; }
      .recharts-default-tooltip {
        background: #000000 !important;
        border: 1px solid #FFFFFF !important;
        color: #FFFFFF !important;
      }
      .recharts-tooltip-label { color: #FFFFFF !important; }
      .recharts-tooltip-item { color: #CCCCCC !important; }
      .recharts-label { fill: #FFFFFF !important; }
      /* Labels on white bars — use black text on white background chip */
      .recharts-bar-label text { fill: #000000 !important; }
    ` : ''}
  `;
}

export default themes;
